/**
 * 日期格式化工具函数
 * 统一整个应用的日期显示格式
 */

/**
 * 格式化日期为中文本地化格式
 * @param {string|Date} date - 要格式化的日期
 * @param {Object} options - 格式化选项
 * @returns {string} 格式化后的日期字符串
 */
export const formatDate = (date, options = {}) => {
  if (!date) return '-';
  
  const defaultOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  };
  
  const finalOptions = { ...defaultOptions, ...options };
  
  try {
    return new Date(date).toLocaleString('zh-CN', finalOptions);
  } catch (error) {
    console.error('Date formatting error:', error);
    return '-';
  }
};

/**
 * 格式化日期为简短格式（仅日期）
 * @param {string|Date} date - 要格式化的日期
 * @returns {string} 格式化后的日期字符串
 */
export const formatDateShort = (date) => {
  return formatDate(date, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

/**
 * 格式化日期为时间格式（仅时间）
 * @param {string|Date} date - 要格式化的日期
 * @returns {string} 格式化后的时间字符串
 */
export const formatTime = (date) => {
  return formatDate(date, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
};